import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { IMyOwnTractorDetail, IMyOwnTractorImage } from '../../../../interfaces/OwnTractor.interfaces';
import { myOwnTractorsApiUrl } from '../../../../api/user/queries/getMyOwnTractorById';
import { getMyOwnTractorImagesById } from '../../../../api/user/queries/getMyOwnTractorImagesById';

interface IUseGetMyOwnTractorImagesByIdQueryParams {
  ownTractorId: string;
  options?: UseQueryOptions<IMyOwnTractorImage[]>;
}

export const useGetMyOwnTractorImagesById = ({ ownTractorId, options }: IUseGetMyOwnTractorImagesByIdQueryParams) => {
  return useQuery<IMyOwnTractorImage[], AxiosError>(
    [`${myOwnTractorsApiUrl}_images_by_id`, ownTractorId],
    () => getMyOwnTractorImagesById({ ownTractorId }),
    {
      enabled: Boolean(ownTractorId) && options?.enabled,
    },
  );
};
